export class EnumUtil {
  static getEnumValue(o: any, key: string, defaultValue?: any) {
    const evalue = Object.values(o)[Object.keys(o).indexOf(key)];
    if (defaultValue) {
      return evalue ?? defaultValue;
    }
    return evalue;
  }
}
